import React from 'react';
import { RateCardAttributesType } from '@institutions/pages/organization/rates-long-term-creation-steps/_rates-long-term-context';
import { Card, DateWithoutTimeZone, Gutter, Text } from '@common/components';
import { roleLevelParser } from '@institutions/services';
import { RatesLongTermPreviewTable } from '@institutions/components';

const shifts = ['day', 'evening', 'night', 'variable'] as const;

export function RatesLongTermStepSummaryRateCard({
  rateCardAttributes,
}: {
  rateCardAttributes: RateCardAttributesType;
}) {
  const dataSource = shifts.map((shift) => ({
    shift,
    traveler: rateCardAttributes?.travelerRate?.[`${shift}BillingRate`],
    local: rateCardAttributes?.localRate?.[`${shift}BillingRate`],
    direct: rateCardAttributes?.directSourcingRate?.[`${shift}BillingRate`],
  }));

  return (
    <Card>
      <Gutter direction="bottom" size="md">
        <Text size="xl" weight="medium">
          {rateCardAttributes?.role?.abbreviation} -{' '}
          {roleLevelParser(rateCardAttributes?.roleLevel)}
        </Text>
      </Gutter>
      <Text size="lg" secondary>
        Start Date:
      </Text>
      <Text size="lg" weight="medium">
        <DateWithoutTimeZone date={rateCardAttributes?.effectiveDate ?? ''} />
      </Text>
      <RatesLongTermPreviewTable dataSource={dataSource} />
    </Card>
  );
}
